












import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import QuickTable from "../../../../../components/table/table.vue";
@Component({
	name:'projectBooks',
	components: {
		QuickTable
	}
})
export default class ProjectBooks extends AbpBase {
	initData:any = {
		columns: [
			{
				title: '项目编号',
				key: 'projectCode'
			},
			{
				title: '项目名称',
				key: 'projectName',
				render: (h:any, params:any) => {
					return h('a', params.row.projectName);
				}
			},
			{
				title: '安全责任领导',
				key: 'dutyLeader',
				render: (h:any, params:any) => {
					return h('span', params.row.dutyLeader ? params.row.dutyLeader.name : '');
				}
			},
			{
				title: '项目负责人',
				key: 'auditLeader',
				render: (h:any, params:any) => {
					return h('span', params.row.auditLeade ? params.row.auditLeader.name : '');
				}
			},
			{
				title: '安全员',
				key: 'safor',
				render: (h:any, params:any) => {
					return h('span', params.row.safor ? params.row.safor.name : '');
				}
			},
			{
				title: '资金来源',
				key: 'fundsSourceDesc'
			},
			{
				title: '项目金额（万元）',
				key: 'projectAmount'
			}
		]
	}
}
